import { updates } from '@/mocks/homepage';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-900">最新快讯</h2>
          <p className="mt-2 text-sm md:text-base text-foreground-600">擦边视频与擦边图片每日更新动态</p>
        </div>

        <div className="relative pl-6 md:pl-8 border-l-2 border-primary-200">
          {updates.map((update, idx) => (
            <div key={idx} className="relative pb-6 md:pb-7 last:pb-0">
              <div className="absolute -left-[25px] md:-left-[29px] w-3 h-3 md:w-3.5 md:h-3.5 rounded-full bg-primary-500 border-2 border-background-50"></div>
              <div className="flex items-center gap-2 mb-1">
                <span className="text-xs text-foreground-500 whitespace-nowrap">{update.time}</span>
                <span className="text-xs px-1.5 py-0.5 bg-accent-100 text-accent-700 rounded whitespace-nowrap font-medium">{update.tag}</span>
              </div>
              <p className="text-sm md:text-base text-foreground-800 font-medium leading-relaxed">{update.title}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}